export default () => {
  const promise = new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_GATEWAY_ENDPOINT}v3/countries`)
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
